import React, { ReactElement } from 'react';

import { SummaryCardRows } from 'src/common/components/skeletons/SummaryCardRows';

import './SummaryLineSkeleton.scss';

interface SummaryLineSkeletonProps {
	animationSpeed?: number;
}

export const SummaryLineSkeleton = ({
	animationSpeed = 0
}: SummaryLineSkeletonProps): ReactElement => {
	return (
		<div className="skeleton-summary-cards">
			<SummaryCardRows
				count={4}
				height="70px"
				width="100%"
				animationSpeed={animationSpeed}
				keySet={Array.from({ length: 4 }, (_, i) => `summary_card_${i}`)}
			/>
		</div>
	);
};
